<template>
    <div>
        <div :id="id" :class="borderWrapper" class="grid grid-cols-3 gap-2 md:gap-4 mb-4">
            <div class="pb-2" :class="[type === 'full' ? 'col-span-3' : 'col-span-3 lg:col-span-1', borderTitle]">
                <slot class="" name="title"></slot>
            </div>
            <div :class="type === 'full' ? 'col-span-3' : 'col-span-3 lg:col-span-2'">
                <slot class="" name="content"></slot>
            </div>
        </div>
        <hr v-if="this.borderPosition === 'bottom'" class="my-8 w-full" :class="borderHr" />
    </div>
</template>

<script>
export default {
    props: ['id', 'type', 'borderPosition'],
    mounted() {
        if (this.borderPosition === 'top') {
            this.borderWrapper = 'border-t border-gray-300';
        } else if (this.borderPosition === 'bottom') {
            this.borderHr = 'border-b-0.5 border-gray-300';
        } else if (this.borderPosition === 'between') {
            this.borderTitle = 'border-b border-gray-300';
        }
    },
    data: () => ({
        borderWrapper: null,
        borderTitle: null,
        borderHr: null
    })
};
</script>
